import React from 'react';
import { InputNumber } from 'primereact/inputnumber';
import Label from '../Label';
import { classNames } from 'primereact/utils';

const FormikInputNumber = (props) => {
  const { labelText, isMandatory = false, formik, name, placeholder, className, ...rest } = props;

  const isInvalid = !!(formik.touched[name] && formik.errors[name]);
  const mergeClassName = classNames(className, {
    'p-invalid': isInvalid
  });
  return (
    <>
      {labelText && <Label htmlFor={name} text={labelText} isMandatory={isMandatory} />}
      <InputNumber
        {...rest}
        id={name}
        name={name}
        placeholder={placeholder}
        value={formik.values[name]}
        className={mergeClassName}
      />
      {isInvalid && <small className="p-error">{formik.errors[name]}</small>}
    </>
  );
};

export default FormikInputNumber;
